import React from 'react';
import { ActionText, Flex } from '../../components/Flex';
import { FixedForm } from '../../components/Forms';
import { Scrollbar } from '../../components/Scrollbar';
import { Paragraph, Title } from '../../components/Text';
import { MarkText } from '../../components/MarkText';
import { ArrowLeftIcon } from '../../icons/ArrowLeftIcon';

const HelpPanel = ({ questions=[], onClose, onShowQuestion, onCloseQuestion, question }) => {
    const wrapBlock = (text, key) => {
        if (typeof text === "string") {
            const re = /(^\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
            text = text.replace(re, '<a href="$1" target="_blank">$1</a>');
            return (
                <MarkText key={key} text={text}/>
            );
        };
        return (
            <div key={key}>
                {text}
            </div>
        );
    };

    return(
        <FixedForm isForm={false} onClose={onClose} padding={{ top: "22px", bottom: "32px" }}>
            <Title h4 margin={{ bottom: "15px" }} style={{ padding: "0 12px 0 32px" }}>FAQ</Title>
            {question
                ? <Flex direction="column" gap={{ bottom: 18 }} flex={1}>
                    <Flex background="var(--sp-light-grey-blue-color)" padding={{ left: "32px", top: "12px", right: "22px", bottom: "12px" }}>
                        <Paragraph bold>{question.question}</Paragraph>
                    </Flex>
                    <ActionText gap={{ right: 8 }} aligny="center" style={{ padding: "0 12px 0 32px" }} onClick={() => onCloseQuestion()}>
                        <ArrowLeftIcon size={20} />
                        <Paragraph bold color="var(--sp-label-color)">Back</Paragraph>
                    </ActionText>
                    <Flex flex={1} padding={{left: "32px", right: "12px" }}>
                        <Scrollbar>
                            <Flex direction="column" padding={{right: "20px" }} gap={{ bottom: 12 }} >
                            {question.video
                                ? wrapBlock(
                                    <iframe
                                        width="100%"
                                        height="232"
                                        src={question.video}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                )
                                : null}
                                {question.answer
                                ? Array.isArray(question.answer)
                                    ? question.answer.map((p, idx) => wrapBlock(p, `paragraph-${idx}`))
                                    : wrapBlock(question.answer)
                                : wrapBlock("That is the question.")}
                            </Flex>
                        </Scrollbar>
                    </Flex>
                </Flex>
                : <Flex direction="column" flex={1} padding={{ right: "12px", left: "32px" }}>
                    <Paragraph margin={{ bottom: "22px" }}>If you have not found your question in this FAQ, contact us at <a href="mailto: spsupport@vmssoftware.com">spsupport@vmssoftware.com</a> &mdash; we are here to help.</Paragraph>
                    <Flex height="calc(100% - 75px)">
                        <Scrollbar>
                            <Flex direction="column" padding={{ right: "20px" }} gap={{ bottom: 18 }}>
                                {questions.map(({ key, question }) => (
                                    <ActionText bold whiteSpace="normal" key={key} onClick={() => onShowQuestion(key)}>{question}</ActionText>
                                ))}
                            </Flex>
                        </Scrollbar>
                    </Flex>
                </Flex>}
        </FixedForm>
    )
};

export { HelpPanel };
